import { Component, ElementRef, ViewChild } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from '@angular/material-moment-adapter';

import moment from 'moment';
import { Moment } from 'moment';
import { FormFieldComponent } from '../form-field.types';

@Component({
  templateUrl: './date-form-field.component.html',
  styleUrls: ['./../form-field.component.scss'],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
    },
    {
      provide: MAT_DATE_FORMATS,
      useValue: {
        parse: {
          dateInput: 'L',
        },
        display: {
          dateInput: 'L',
          monthYearLabel: 'MMM YYYY',
          dateA11yLabel: 'L',
          monthYearA11yLabel: 'MMMM YYYY',
        },
      },
    },
  ],
})
export class DateFormFieldComponent extends FormFieldComponent {
  @ViewChild('inputControl') inputControl: ElementRef;

  private _originalValue: string;

  public dateDisplayFormat = 'MM/DD/YYYY';
  public editing = false;
  public date = new UntypedFormControl(null);

  private syncDisabledState(): void {
    // [SC-57579] With `matDatepickerInput` + reactive forms, the FormControl's disabled state is authoritative.
    // Keep it in sync with the computed `isDisabled` (locked/readonly/archived/value_hidden).
    if (this.isDisabled) {
      if (!this.date.disabled) this.date.disable({ emitEvent: false });
    } else {
      if (this.date.disabled) this.date.enable({ emitEvent: false });
    }
  }

  get displayValue(): string {
    return 'REDACTED';
  }

  get modelFieldValue(): string {
    return this.model[this.fieldDef.name];
  }

  get modelFieldMomentValue(): Moment {
    return moment(this.modelFieldValue || '');
  }

  get modelFieldFormattedValue(): string {
    return this.modelFieldMomentValue?.format(this.dateDisplayFormat);
  }

  get dateFieldFormattedValue(): string {
    return this.date.value?.format(this.dateDisplayFormat);
  }

  ngOnInit(): void {
    super.ngOnInit();

    this._originalValue = this.modelFieldFormattedValue;

    this.date.setValue(this.modelFieldMomentValue);

    this.model[this.fieldDef.name] = this.date.value;

    this.syncDisabledState();
  }

  onDateChange(): void {
    if (this._originalValue !== this.dateFieldFormattedValue) {
      const dbFormattedDate = this.date.value?.format('YYYY-MM-DD');
      if (dbFormattedDate) this.save(dbFormattedDate);
      else this.date.setErrors({ incorrect: true });
    }
  }

  dateBlur(event: FocusEvent & { target: HTMLInputElement }): void {
    if (event.target.value === '') {
      this.date.setValue(null);
      if (this._originalValue) this.save(this.date.value);
    }
  }

  save(date: string): void {
    this.model[this.fieldDef.name] = date;
    this._originalValue = this.dateFieldFormattedValue;
    this.update.emit({ [this.fieldDef.name]: date });
  }

  updateChangedModel?(model: any): void {
    this.model = model;
    this.date.setValue(this.modelFieldMomentValue);
    this.syncDisabledState();
  }
}
